import script from "./legends.modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./legends.modal.vue?vue&type=script&lang=ts&setup=true"

import "./legends.modal.vue?vue&type=style&index=0&id=53d861aa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d861aa"]])

export default __exports__